import { useMemo } from 'react'

export const useAdminBuilderSlice = <TBuilderPage, TOpenPageInBuilder, TSaveBuilderPage, TSetBuilderPage>({
  builderPage,
  builderLoading,
  openPageInBuilder,
  saveBuilderPage,
  setBuilderPage,
}: {
  builderPage: TBuilderPage
  builderLoading: boolean
  openPageInBuilder: TOpenPageInBuilder
  saveBuilderPage: TSaveBuilderPage
  setBuilderPage: TSetBuilderPage
}) =>
  useMemo(
    () => ({
      builderPage,
      builderLoading,
      openPageInBuilder,
      saveBuilderPage,
      setBuilderPage,
    }),
    [builderLoading, builderPage, openPageInBuilder, saveBuilderPage, setBuilderPage],
  )
